window.EG_COLLECTION_PICKER_RANKING = (function () {
  function hasTag(tags, fullTag) {
    if (!tags || !tags.length || !fullTag) return false;

    var needle = String(fullTag);
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i] || "") === needle) return true;
    }
    return false;
  }

  function readTagMm(tags, prefix) {
    if (!tags || !tags.length || !prefix) return 0;

    for (var i = 0; i < tags.length; i++) {
      var t = String(tags[i] || "");
      if (t.indexOf(prefix) !== 0) continue;

      var raw = t.slice(prefix.length).replace(/[^\d.]/g, "");
      var n = parseFloat(raw);
      if (isFinite(n)) return n;
    }

    return 0;
  }

  function readAreaMm2(tags) {
    var w = readTagMm(tags, "Width_");
    var l = readTagMm(tags, "Length_");
    if (!w || !l) return 0;
    return w * l;
  }

function scoreMousepads(product, pickerState, weights) {
    if (!product) return 0;

    var tags = Array.isArray(product.tags) ? product.tags : [];
    weights = weights || {};
    var wMove = (weights.movement_space != null) ? weights.movement_space : 1;
    var wPriority = (weights.secondary_priority != null) ? weights.secondary_priority : 1;
    var egBias = (weights.eg_bias != null) ? weights.eg_bias : 0;
    var score = 0;

    var movement = String((pickerState && pickerState.movement_space) || "");
    var priority = String((pickerState && pickerState.secondary_priority) || "");

    var area = readAreaMm2(tags);
    var width = readTagMm(tags, "Width_");
    var length = readTagMm(tags, "Length_");

    // -------------------------
    // movement_space
    // -------------------------
      if (movement === "large_space") {
        if (area >= 240000) score += 40 * wMove;
        else if (area >= 200000) score += 24 * wMove;
        else if (width >= 490 || length >= 490) score += 18 * wMove;
        else score -= 8 * wMove;
      } else if (movement === "medium_space") {
        if (area >= 180000 && area <= 260000) score += 30 * wMove;
        else if (area >= 150000 && area <= 300000) score += 16 * wMove;
        else score -= 4 * wMove;
      } else if (movement === "compact_space") {
        if (area > 0 && area <= 190000) score += 34 * wMove;
        else if (area <= 230000) score += 12 * wMove;
        else score -= 10 * wMove;
      }

    // -------------------------
    // secondary_priority
    // -------------------------
    if (priority === "comfort") {
      if (hasTag(tags, "Firmness__Extra Soft")) score += 28 * wPriority;
      else if (hasTag(tags, "Firmness__Soft")) score += 20 * wPriority;

      if (hasTag(tags, "Thickness_4mm")) score += 6 * wPriority;
      if (hasTag(tags, "Thickness_5mm")) score += 8 * wPriority;
      if (hasTag(tags, "Thickness_6mm")) score += 10 * wPriority;
    } else if (priority === "consistency") {
      if (hasTag(tags, "Firmness__Mid")) score += 24 * wPriority;
      if (hasTag(tags, "Firmness__Hard")) score += 18 * wPriority;
      if (hasTag(tags, "Surface Texture__Smooth")) score += 8 * wPriority;
      if (hasTag(tags, "Surface Texture__Slightly Grainy")) score += 6 * wPriority;
      if (hasTag(tags, "Surface Texture__Slightly Textured")) score += 6 * wPriority;
    } else if (priority === "durability") {
      if (hasTag(tags, "Surface Material_Cordura")) score += 30 * wPriority;
      if (hasTag(tags, "Stitched Edges_Yes")) score += 10 * wPriority;
      if (hasTag(tags, "Washable__Yes (Wipe Clean)")) score += 10 * wPriority;
      if (hasTag(tags, "Washable__Yes")) score += 8 * wPriority;
      if (hasTag(tags, "Packaging Type__Flat")) score += 4 * wPriority;
    } else if (priority === "low_friction") {
      if (hasTag(tags, "Surface Type__Speed")) score += 18 * wPriority;
      if (hasTag(tags, "Surface Texture__Ultra Smooth")) score += 18 * wPriority;
      if (hasTag(tags, "Dynamic Friction__Very Low")) score += 22 * wPriority;
      if (hasTag(tags, "Dynamic Friction__Low")) score += 12 * wPriority;
      if (hasTag(tags, "Static Friction__Very Low")) score += 18 * wPriority;
      if (hasTag(tags, "Static Friction__Low")) score += 10 * wPriority;
    }

    if (product && (product.legacy_collection === false || product.legacy_collection === 0 || product.legacy_collection === "0" || product.legacy_collection === "false")) {
      score += egBias;
    }

    return score;
  }

  return {
    handles: {
      "test-collection": {
        score: scoreMousepads,
        weights: {
          movement_space: 1.6,
          secondary_priority: 0.9,
          eg_bias: 5
        }
      }
    }
  };
})();